module.exports = __webpack_public_path__ + "static/Victoria-f245590a103150cc08ac83508c46fae7.jpg";